export function buttonTarget() {
	$('button[data-href], .is-fake-button').click( function( e ){
		let target = $(e.target);
		if ( target.not( 'a' )) {
			e.preventDefault();
			var timeout = 250;
			var $this = $( this );
			if ( 'undefined' != typeof $this.attr('data-datalayer') ) {
				var $dataLayer = $this.attr('data-datalayer');
				timeout = 1000;
				$dataLayer = $.parseJSON( $dataLayer );
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push( $dataLayer );
				if ( customData.debug_on ) {
					console.log('Pushing GTM event...');
					console.log( $dataLayer );
				}
			}
			setTimeout(function() {
				if ( customData.debug_on ) {
					console.log('Redirecting in ' + timeout + 'ms...');
				}
				if ( $this.attr( 'data-window' ) == 'new' ) {
					window.open( $this.attr( 'data-href' ) );
				} else {
					window.location.href = $this.attr( 'data-href' );
				}
			}, timeout );
			return false;
		}
	});
}

export function init() {
	buttonTarget();
}
